import axios from "axios";
import { DonationURL } from "../../../config/UrlEndPoint";

export const URL = `${DonationURL}thk_partner`;

// Get Partner All For use Combobox data
export function getPartnerAll() {
  return axios.get(URL);
}

export function searchPartner(queryString) {
    return axios.get(`${URL}/search?${queryString}`);
}

//Get By ID
export function getPartnerById(partnerId) {
  return axios.get(`${URL}/${partnerId}`);
}

// items => filtered/sorted result for table data
export function findPartner(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the partner on the server
export function createPartner(partner) {
  return axios.post(URL, partner);
}

// UPDATE => PUT: update the partner on the server
export function updatePartner(partner) {
  return axios.put(`${URL}/${partner.uuid}`, partner);
}

// UPDATE => Delete: Delete the partner on the server
export function deletePartner(uuid) {
  return axios.delete(`${URL}/${uuid}`);
}
